"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkedErrorsIntegration = void 0;

var _core = require("@sentry/core");

var _eventbuilder = require("../eventbuilder.js");

const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = (options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,

    preprocessEvent(event, hint, client) {
      const options = client.getOptions();
      (0, _core.applyAggregateErrorsToEvent)( // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
      _eventbuilder.exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
    }

  };
};
/**
 * Aggregrate linked errors in an event.
 */


const linkedErrorsIntegration = exports.linkedErrorsIntegration = (0, _core.defineIntegration)(_linkedErrorsIntegration);